var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCorseright(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7275 0.740909C11.521 0.748197 11.3315 0.857515 11.2222 1.03243L5.37246 9.98199L1.58274 6.70728C1.41998 6.53845 1.17583 6.47529 0.951121 6.54574C0.727625 6.61497 0.561218 6.80446 0.522349 7.03524C0.48348 7.26724 0.577008 7.50045 0.766494 7.64014L5.10038 11.391C5.23642 11.5064 5.41619 11.5574 5.59231 11.5319C5.76965 11.5052 5.92634 11.4043 6.02351 11.2549L12.2717 1.71263C12.4053 1.51707 12.4162 1.26442 12.3008 1.05793C12.1854 0.852657 11.9632 0.729977 11.7275 0.740909Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorseright);
export default __webpack_public_path__ + "static/media/corseright.005722f88c8558bb396b030ea89e83b7.svg";
export { ForwardRef as ReactComponent };